import useAuthStore from "@/stores/useAuthStore";
import { storeToRefs } from "pinia";
import { Router } from "vue-router";

export default function (router: Router) {
  const authStore = useAuthStore();
  const {
    session,
  } = storeToRefs(authStore);

  router.beforeEach(async () => {
    if (!session.value) {
      await authStore.fetchSession();
    }
  });
}
